import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { propertyCardBadgeAreaStyles } from './styles/property-card-badge-area.styles';
import type { PropertyCardBadgeAreaPropsInterface } from './types/property-card-badge-area.types';

/**
 * A container for the badge in a `PropertyCard`.
 *
 * @since 8.67.
 */
export const PropertyCardBadgeArea = forwardRef<
  HTMLDivElement,
  PropertyCardBadgeAreaPropsInterface
>((props: PropertyCardBadgeAreaPropsInterface, forwardedRef) => {
  const { children, className, css: cssProp, ...rest } = props;

  const styles = css(propertyCardBadgeAreaStyles, cssProp);

  return (
    <div
      ref={forwardedRef}
      data-c11n-component="PropertyCard.BadgeArea"
      data-c11n-version={__C11N_VERSION__}
      className={cx('c11n', styles, className)}
      {...rest}
    >
      {children}
    </div>
  );
});

PropertyCardBadgeArea.displayName = 'PropertyCard.BadgeArea';
